// src/Components/ImportMarkers/ExcelDialogs.js

import React from 'react';
import ExcelDialogAssignProperty from './ExcelDialogAssignProperty';
import ExcelDialogPhoto from './ExcelDialogPhoto';
import ExcelDialogDesc from './ExcelDialogDesc';
import ExcelDialogDocument from './ExcelDialogDocument';

export default function ExcelDialogs({ state, flags, alerts, actions }) {
  if (state.invalidMatchState?.open) {
    if (state.invalidMatchState.type === 'DESCRIPTION') {
      return <ExcelDialogDesc state={state} actions={actions} />;
    }
    return <ExcelDialogAssignProperty state={state} actions={actions} />;
  }

  if (state.manualMatchRowId) {
    return <ExcelDialogPhoto state={state} actions={actions} />;
  }

  if (state.documentMatchRowId) {
    // The key prop forces a complete unmount/remount when navigating between rows
    return (
      <ExcelDialogDocument
        key={state.documentMatchRowId}
        state={state}
        actions={actions}
      />
    );
  }

  return null;
}
